import { Dropdown } from "react-bootstrap";
import {
  formatGeneralExpenseAmount,
  formatGeneralExpenseDate,
} from "../utils/general-expense.utils";

const GeneralExpensesTable = ({ expenses, onEdit, onDelete, isDeleting }) => {
  return (
    <div className="table-responsive">
      <table className="table table-striped">
        <thead>
          <tr>
            <th>#</th>
            <th>Expense Type</th>
            <th>Amount</th>
            <th>Description</th>
            <th>Expense Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {expenses.map((expense, index) => (
            <tr key={expense._id || `${expense.expenseType}-${index}`}>
              <td>{index + 1}</td>
              <td>{expense.expenseType || "-"}</td>
              <td>{formatGeneralExpenseAmount(expense.amount)}</td>
              <td>{expense.description || "-"}</td>
              <td>{formatGeneralExpenseDate(expense.expenseDate)}</td>
              <td>
                <Dropdown>
                  <Dropdown.Toggle variant="link" className="p-0 text-decoration-none">
                    &#x2022;&#x2022;&#x2022;
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end">
                    <Dropdown.Item onClick={() => onEdit(expense._id)} disabled={!expense._id}>
                      Edit
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => onDelete(expense)}
                      className="text-danger"
                      disabled={!expense._id || isDeleting}
                    >
                      Delete
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default GeneralExpensesTable;
